import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { NodeEdgeMapper } from '@iotv/datamodel-core';
import { getObjectHash } from '@iotv/iotv-v3-types';
import { Alert, Grid, Skeleton, Stack } from '@mui/material';
import { useCallback, useEffect, useReducer, useRef } from 'react';
import { getNodeEdgeMapperReducer } from '../../../ContextProviders/NodeEdgeMapperComponentContext';
import { GoogleMapAPIMapTypeIds } from '../../../GoogleMapV4';
import { PlaceUpdateableLabelFn } from '../../../GoogleMapV4/components/Labels/PlaceUpdateablePortalLabel';
import { useVenturePlaceStyleFn } from '../../../GoogleMapV4/hooks/useVenturePlaceStyleFn';
import { useThemedMap } from '../../../GoogleMapV4/useThemedMap';
import { ObjectDetailCard } from '../../../v2/components/generic/ObjectView/ObjectDetailCard';
import { getPlaceViewDefinition } from '../viewDefinitions';
const debug = process.env.REACT_APP_DEBUG && false;
/** shimmed for NetworkCoverage */
const areaData = [];
const lineDefiningPairs = [];
const nemReducer = getNodeEdgeMapperReducer({ canaryString: 'areaDetailMapReducer' });
export const PlaceDetail = ({ contextPlace, transactionFunctions, userFunctions, isSmallView, allowedActions }) => {
    const viewDefinition = getPlaceViewDefinition();
    const [{ nodeEdgeMapper: mapNem, nemHash }, mapDispatch] = useReducer(nemReducer, {
        nodeEdgeMapper: new NodeEdgeMapper(),
        nemHash: null,
        apexNode: null,
    });
    const PlaceLabelFnRef = useRef(({ vob }) => _jsx(PlaceUpdateableLabelFn, { vob, contextPlace }));
    const { placeStyleFn } = useVenturePlaceStyleFn();
    const getUseThemedMapInput = useCallback(() => {
        debug && console.log(`AreaDetailCard useThemedMapInput callback`, nemHash);
        return {
            canaryString: 'AreaDetailCard',
            contextObject: contextPlace,
            nodeEdgeMapper: mapNem,
            areaData,
            lineDefiningPairs,
            nodeEdgeMapperDispatch: mapDispatch,
            transactionFunctions,
            options: {
                tilt: 0,
                mapTypeId: GoogleMapAPIMapTypeIds.terrain,
                mapTypeControlOptions: {
                    position: google.maps.ControlPosition.BOTTOM_RIGHT,
                },
                controlSize: 24,
            },
            dataFn: (async (gob) => {
                return { ...gob, data: {} };
            }),
            functions: {},
            showDrawingTools: true,
            themesAndLabels: {
                Place: {
                    LabelComponent: PlaceLabelFnRef.current,
                    styleFn: placeStyleFn,
                },
            },
        };
    }, [mapNem, contextPlace, nemHash]);
    const { map, components: { PortalDiv, MapDatalayerVisibility, MapLegend }, quarantinedItemsDialog, mapActionsDialog, } = useThemedMap(getUseThemedMapInput());
    // Ensures that manual updates to the place are reflected on the map
    const placeHash = getObjectHash(contextPlace);
    useEffect(() => {
        mapDispatch({ type: 'loadItems', value: { items: [contextPlace] } });
    }, [contextPlace.sk, placeHash]);
    const direction = isSmallView ? 'column' : 'row';
    const controlsMargin = 12;
    const controlsWidth = isSmallView ? '250px' : `calc(100% - ${2 * controlsMargin}px)`;
    const justifyContent = isSmallView ? undefined : 'flex-end';
    const spacing = isSmallView ? 0 : 1;
    const controlsStack = (_jsxs(Stack, { width: controlsWidth, spacing, direction, sx: { zIndex: 2, height: 0, position: 'relative', top: controlsMargin, left: controlsMargin }, children: [_jsxs(Stack, { direction, spacing, width: isSmallView ? undefined : '75%', children: [_jsx(Stack, { id: 'visibility', children: MapDatalayerVisibility }, 'nwcmMapDatalayerVisibility'), _jsx(Stack, { id: 'mapControlModalBase' }, 'EC')] }, 'left'), _jsx(Stack, { direction, width: isSmallView ? '100%' : '25%', justifyContent, children: _jsx(Stack, { id: 'legend', children: MapLegend }, 'nwcmLeg') }, 'right')] }, 'controls'));
    return (_jsxs(Stack, { gap: 1, children: [contextPlace && (_jsx(ObjectDetailCard, { mostProximateCustomer: undefined,
                matchedPrimary: contextPlace,
                transactionFunctions,
                userFunctions,
                viewDefinition,
                //editMode: ComponentMode.EDIT,
                //deletable: true,
                allowedActions })), contextPlace && !contextPlace.location && _jsxs(Alert, { severity: "info", children: [contextPlace.name, " does not have a map place"] }), _jsx(Grid, { container: true, children: _jsxs(Grid, { size: 12, sx: { minHeight: isSmallView ? '40vh' : '72cqh' }, children: [PortalDiv, controlsStack, map.current, !map.current && _jsx(Skeleton, { animation: 'wave', variant: 'rectangular', height: '100%' })] }) }), mapActionsDialog] }));
};
